import styled from 'styled-components';

export const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-width: 300px;
  margin: 0;

  button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    background-color: #cdd1d1;
    border: 1px solid #cdd1d1;
    color: #5e5e5e;
    font-family: inherit;
    font-size: 1.7rem;
    outline: none;
    cursor: pointer;
    text-align: left;

    &:hover,
    &:focus {
      outline: 2px solid #169BA2;
      outline-offset: -2px;
    }
  }

  ul {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 160px;
    padding-left: 0;
    margin: 0;
    background-color: #fff;
    border-radius: 0;
    box-shadow: 0 4px 6px 1px rgba(0, 0, 0, 0.15);
    list-style: none;
    overflow-y: auto;
    z-index: 3;
    
    @media all and (min-width: 767px) {
      height: 302px;
    }

    li {
      display: flex;
      width: 100%;
      padding: 12px 10px;
      border: 1px solid #e5e5e5;
      text-decoration: none;
      color: #5e5e5e;
      cursor: pointer;
      font-size: 1.9rem;
      outline: none;

      &:focus {
        background-color: #f1f2f2;
        outline: 2px solid #169BA2;
        outline-offset: -2px;
      }
      
      &:hover {
        background-color: #f1f2f2;
      }
    }
  }
`;

